__webpack_require__.p = "/capture-rings/";